import AdminRepository from '../services/AdminRepository.js';
import { bootStart, bootEnd } from './bootTiming.js';

let prefetchPromise = null;
let prefetchResult = null;

/**
 * セッション確立直後に dashboard-summary を先読み（認証復元と並列）
 * ネットワークは1本に集約。ダッシュボード側はインスタンスの cancelled で setState を制御する。
 */
export function startDashboardPrefetch() {
  if (prefetchResult) {
    return Promise.resolve(prefetchResult);
  }
  if (!prefetchPromise) {
    bootStart('prefetch:dashboard-summary');
    prefetchPromise = AdminRepository.getInstance()
      .getDashboardSummary()
      .then((data) => {
        prefetchResult = data;
        bootEnd('prefetch:dashboard-summary', 'ok');
        return data;
      })
      .catch((err) => {
        prefetchPromise = null;
        bootEnd('prefetch:dashboard-summary', `error: ${err?.message || 'unknown'}`);
        throw err;
      });
  }
  return prefetchPromise;
}

/**
 * 進行中または完了済みの先読み Promise を返す（なければ null）
 */
export function consumeDashboardPrefetch() {
  if (prefetchResult) {
    return Promise.resolve(prefetchResult);
  }
  return prefetchPromise;
}

export function resetDashboardPrefetch() {
  prefetchPromise = null;
  prefetchResult = null;
}
